import { render, staticRenderFns } from "./RolePicker.vue?vue&type=template&id=d4c1235c&scoped=true&"
import script from "./RolePicker.vue?vue&type=script&lang=ts&"
export * from "./RolePicker.vue?vue&type=script&lang=ts&"
import style0 from "./RolePicker.vue?vue&type=style&index=0&id=d4c1235c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c1235c",
  null
  
)

export default component.exports